import { MapScopedKeyMap } from 'ia-react-core/~/interfaces/MapScopedKeyMap';

export default function getDst<
  Type extends string,
  IdName extends string,
  Target extends Partial<Record<
    `${Type}Dst` | `${Type}Src`,
    string |((props: Record<IdName, number>) => string)|MapScopedKeyMap<Record<IdName, number>>
  >> & Partial<Record<IdName, number>>
>(type: Type, props: Target, { idName }: { idName?: IdName } = {}): string {
  const { [idName]: id } = props;
  const dst = props[`${type}Dst`];
  const src = props[`${type}Src`];

  if (typeof dst === 'function') {
    return dst({ [idName]: id });
  }

  if (typeof dst === 'string') {
    return dst;
  }

  if (typeof src === 'string') {
    return src;
  }

  return undefined;
}
